import { Injectable, OnDestroy } from '@angular/core';
import { ViewFault } from '@docma-mm-core/fault/fault';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class MmFaultsHoverService implements OnDestroy {

  private mouseOverFault = new BehaviorSubject<ViewFault>(null);
  onMouseOverFault = this.mouseOverFault.asObservable();

  private mouseOutFault = new BehaviorSubject<ViewFault>(null);
  onMouseOutFault = this.mouseOutFault.asObservable();

  constructor() {
  }

  ngOnDestroy(): void {
  }

  setMouseOver(fault: ViewFault) {
    this.mouseOverFault.next(fault);
  }

  setMouseOut(fault: ViewFault) {
    this.mouseOutFault.next(fault);
  }

}
